var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amui-card-section",class:{ 'amui-card-section--small': _vm.small }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }